export default __webpack_public_path__ + "static/media/arise.16595301.png";